import Plus from '~/images/shared/Add.svg';

const AddFieldCTA: React.FC<{ handleAddField: () => void }> = ({
  handleAddField,
}) => {
  return (
    <div
      className='flex h-[68px] w-72 cursor-pointer flex-col items-center justify-center gap-5 rounded-xl border-xs border-outline-default'
      onClick={handleAddField}
    >
      <Plus />
    </div>
  );
};

export default AddFieldCTA;
